import ProfileScreen from "@/UI/screens/ProfileScreen";

export default function ProfileRoute() {
    return <ProfileScreen />;
}
